export * from './accesspoint.controller';
import prompted_entry1 from './prompted_entry1.html';
import prompted_entry2 from './prompted_entry2.html';

export { prompted_entry1, prompted_entry2 }
